import type { RefObject } from 'react';

import { SDSInternalSpinner } from '@repo/sds/components/_internal/SDSInternalSpinner';
import { SDSFlexbox } from '@repo/sds/components/SDSFlexbox';
import { SDSTableCell } from '@repo/sds/components/SDSTable/SDSTableCell';
import { SDSTableRow } from '@repo/sds/components/SDSTable/SDSTableRow';

interface SDSTableLoadingTriggerProps {
  triggerRef: RefObject<HTMLDivElement | null>;
  isLoading: boolean;
  colSpan: number;
}

export function SDSTableLoadingTrigger({ triggerRef, isLoading, colSpan }: SDSTableLoadingTriggerProps) {
  return (
    <SDSTableRow>
      <SDSTableCell colSpan={colSpan}>
        <div ref={triggerRef}>
          <SDSFlexbox className="SDSTable__loading-trigger" justifyContent="center" alignItems="center">
            {isLoading && <SDSInternalSpinner />}
          </SDSFlexbox>
        </div>
      </SDSTableCell>
    </SDSTableRow>
  );
}
